import { Box, Checkbox, FormControlLabel, FormGroup, LinearProgress, Tooltip, Typography } from '@mui/material';
import Warning from '@mui/icons-material/Warning';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import FiltrosAtivos from './FiltrosAtivos';

class OperacoesEmLoteSelecionar extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            selecionarTodos: action,
            selecionarProximos: action,
            processosSelecionados: computed,
            todosSelecionados: computed,
            proximosSelecionados: computed,
            toggleSelecionarTodos: action,
            toggleSelecionarProximos: action,
            todosSelecionadosPublicar: computed,
            toggleSelecionarTodosPublicar: action
        });
    }

    componentDidMount() {
        this.store.resetCheckedOperacoesEmLote();
    }

    componentWillUnmount() {
        this.store.resetCheckedOperacoesEmLote();
    }

    selecionarTodos() {
        if (this.todosSelecionados) {
            this.store.resetCheckedOperacoesEmLote();
        } else {
            this.processosSelecionaveis.forEach((registro) => this.store.checkOperacoesEmLote(registro));
        }
    }

    selecionarProximos() {
        let novoValor = !this.proximosSelecionados;
        let quantidadeSelecionados = 0;
        if (novoValor === true) {
            this.processosSelecionaveis.forEach((registro) => {
                if (quantidadeSelecionados < this.observableProps.quantidadeSelecaoProximos) {
                    this.store.checkOperacoesEmLote(registro);
                    quantidadeSelecionados++;
                } else {
                    this.store.uncheckOperacoesEmLote(registro);
                }
            });
        } else {
            this.store.resetCheckedOperacoesEmLote();
        }
    }

    get processos() {
        return this.observableProps.processos || [];
    }

    get processosSelecionaveis() {
        return this.observableProps.publicarPauta
            ? (this.observableProps.processosSelecionaveis || []).filter(
                  (registro) => !registro.confirmadaInclusaoPauta && this.filtrarProcessoPeloNumero(registro)
              )
            : this.observableProps.processosSelecionaveis || [];
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get todosSelecionados() {
        return (
            this.processosSelecionaveis.findIndex((registro) => !this.store.isCheckedOperacoesEmLote(registro)) === -1
        );
    }

    get proximosSelecionados() {
        return (
            this.processosSelecionaveis
                .slice(0, this.observableProps.quantidadeSelecaoProximos)
                .findIndex((registro) => !this.store.isCheckedOperacoesEmLote(registro)) === -1 &&
            this.processosSelecionaveis
                .slice(this.observableProps.quantidadeSelecaoProximos)
                .findIndex((registro) => this.store.isCheckedOperacoesEmLote(registro)) === -1
        );
    }

    toggleSelecionarTodos = () => {
        this.selecionarTodos();
    };

    toggleSelecionarProximos = () => {
        this.selecionarProximos();
    };

    get todosSelecionadosPublicar() {
        return (
            this.processosSelecionados.length > 0 &&
            this.processosSelecionados.findIndex((registro) => !registro.checkedPublicacaoPauta) === -1
        );
    }

    toggleSelecionarTodosPublicar = () => {
        let novoValor = !this.todosSelecionadosPublicar;
        this.processosSelecionados.forEach((registro) => (registro.checkedPublicacaoPauta = novoValor));
    };

    render() {
        if (this.sessaoStore.carregandoProcessos || this.store.carregandoProcessos) {
            return null;
        }

        return (
            <>
                {this.appStore.requisicoesPendentes && <LinearProgress color="secondary" />}
                <div style={{ margin: '8px 20px' }}>
                    <FiltrosAtivos />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>{this.renderInformacoesProcessos()}</div>
            </>
        );
    }

    renderInformacoesProcessos() {
        if (this.processosSelecionaveis.length > 0) {
            return (
                <>
                    {this.renderSelecionarTodos()}
                    {this.observableProps.exibirBotaoSelecaoProximos ? this.renderSelecionarProximos() : null}
                    {this.renderPublicarTodos()}
                </>
            );
        }

        return (
            <Typography
                variant="subtitle1"
                style={{ fontWeight: 'bold', marginLeft: '25px' }}
            >
                {this.renderTotalizadores()}
            </Typography>
        );
    }

    renderSelecionarTodos() {
        return (
            <FormGroup>
                <FormControlLabel
                    style={{ margin: '0px 25px' }}
                    control={
                        <Checkbox
                            checked={this.todosSelecionados}
                            onChange={this.toggleSelecionarTodos}
                            disabled={this.observableProps.desabilitarBotaoSelecionarTodos}
                        />
                    }
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold' }}
                            >
                                {'Selecionar todos (' + this.renderTotalizadores() + ')'}
                            </Typography>
                            {this.props.mensagemDesabilitacaoBotaoSelecionarTodos ? (
                                <Tooltip
                                    title={this.props.mensagemDesabilitacaoBotaoSelecionarTodos}
                                    sx={{ ml: 1 }}
                                >
                                    <Warning style={{ fill: 'darkorange' }} />
                                </Tooltip>
                            ) : null}
                        </Box>
                    }
                />
            </FormGroup>
        );
    }

    renderSelecionarProximos() {
        return (
            <FormGroup>
                <FormControlLabel
                    style={{ margin: '0px 25px' }}
                    control={
                        <Checkbox
                            checked={this.proximosSelecionados}
                            onChange={this.toggleSelecionarProximos}
                        />
                    }
                    label={
                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 'bold' }}
                        >
                            {'Selecionar próximos ' + this.observableProps.quantidadeSelecaoProximos + ' registros'}
                        </Typography>
                    }
                />
            </FormGroup>
        );
    }

    renderPublicarTodos() {
        return (
            this.observableProps.publicarPauta && (
                <FormGroup>
                    <FormControlLabel
                        style={{ margin: '0px 25px' }}
                        control={
                            <Checkbox
                                checked={this.todosSelecionadosPublicar}
                                onChange={this.toggleSelecionarTodosPublicar}
                            />
                        }
                        label={
                            <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold' }}
                            >
                                Publicar todos os selecionados
                            </Typography>
                        }
                    />
                </FormGroup>
            )
        );
    }

    renderTotalizadores() {
        return (
            (this.salaSessaoStore.existeFiltroAtivo ? 'Filtrados: ' : 'Total: ') +
            this.processos.length +
            ' / selecionáveis: ' +
            this.processosSelecionaveis.length +
            ' / selecionados: ' +
            this.processosSelecionados.length
        );
    }
}

export default inject('stores')(observer(OperacoesEmLoteSelecionar));
